import { css } from "../../../../styled-system/css";
import { t } from "../../../libs/i18n";
import { formatNumber } from "../../../libs/utils";

type KyotoRepresentativeCampaignCompleteModalProps = {
  amount: number;
  onClose: () => void;
};

export function KyotoRepresentativeCampaignCompleteModal({
  amount,
  onClose,
}: KyotoRepresentativeCampaignCompleteModalProps) {
  return (
    // biome-ignore lint/a11y/useKeyWithClickEvents: Modal backdrop click handler
    <div
      className={css({
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(226, 226, 226, 0.5)",
        backdropFilter: "blur(4px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
        px: "20px",
      })}
      onClick={onClose}
    >
      {/* biome-ignore lint/a11y/useKeyWithClickEvents: Prevent closing when clicking modal content */}
      <div
        className={css({
          backgroundColor: "surface.primary",
          border: "1px solid",
          borderColor: "border.secondary",
          borderRadius: "16px",
          boxShadow: "0px 4px 12px 0px rgba(0, 0, 0, 0.04)",
          padding: "24px",
          width: "100%",
          maxWidth: "350px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "24px",
        })}
        onClick={(event) => event.stopPropagation()}
      >
        <h2
          className={css({
            fontSize: "18px",
            lineHeight: "1.35",
            fontWeight: "600",
            color: "text.primary",
            textAlign: "center",
          })}
        >
          {t("ポイントを受け取りました")}
        </h2>

        <div
          className={css({
            width: "100%",
            backgroundColor: "surface.accentSuccessLight",
            borderRadius: "12px",
            px: "20px",
            py: "12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          })}
        >
          <p
            className={css({
              color: "text.secondary",
              fontSize: "14px",
              lineHeight: "1.4",
              textAlign: "center",
            })}
          >
            {t("獲得ポイント")}
          </p>
          <div
            className={css({
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              gap: "4px",
              pl: "12px",
            })}
          >
            <span
              className={css({
                color: "text.accentSuccess",
                fontSize: "40px",
                lineHeight: "1.38",
                letterSpacing: "-0.4px",
              })}
            >
              {formatNumber(amount)}
            </span>
            <span
              className={css({
                color: "text.secondary",
                fontSize: "20px",
                lineHeight: "1.6",
                pb: "8px",
              })}
            >
              pt
            </span>
          </div>
        </div>

        <button
          type="button"
          className={css({
            minH: "48px",
            width: "100%",
            backgroundColor: "#F8FAFC",
            color: "text.primary",
            border: "1px solid",
            borderColor: "border.secondary",
            borderRadius: "12px",
            px: "24px",
            py: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "16px",
            lineHeight: "1.25",
            fontWeight: "600",
            boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.03)",
          })}
          onClick={onClose}
        >
          {t("閉じる")}
        </button>
      </div>
    </div>
  );
}
